/**
 * Localized copy for the order self-edit block reasons. The BE sends a
 * stable `notEditableReasonCode` (Order::customerEditBlockReasonCode) plus
 * the English `notEditableReason` fallback; brands map the code to their
 * language here. Admin-mode reasons stay English (code is null).
 */
const COPY = {
  clsdk: {
    processing: 'Denne ordre er allerede under behandling og kan ikke længere ændres.',
    shop_closed: 'Shoppen for denne ordre er lukket.',
    class_closed: 'Klassen for denne ordre er lukket.',
    payment_deadline_passed: 'Betalingsfristen for denne ordre er udløbet.',
  },
  clsse: {
    processing: 'Denna beställning behandlas redan och kan inte längre ändras.',
    shop_closed: 'Butiken för denna beställning är stängd.',
    class_closed: 'Klassen för denna beställning är stängd.',
    payment_deadline_passed: 'Betalningsfristen för denna beställning har passerat.',
  },
  abcse: {
    processing: 'Denna beställning behandlas redan och kan inte längre ändras.',
    shop_closed: 'Butiken för denna beställning är stängd.',
    class_closed: 'Klassen för denna beställning är stängd.',
    payment_deadline_passed: 'Betalningsfristen för denna beställning har passerat.',
  },
  clsfi: {
    processing: 'Tätä tilausta käsitellään jo, eikä sitä voi enää muuttaa.',
    shop_closed: 'Tämän tilauksen kauppa on suljettu.',
    class_closed: 'Tämän tilauksen luokka on suljettu.',
    payment_deadline_passed: 'Tämän tilauksen maksuaika on päättynyt.',
  },
};

/** Localized block reason for the brand, else the (English) fallback text. */
export const editBlockReasonFor = (brandSlug, code, fallback) =>
  (code && COPY[brandSlug]?.[code]) || fallback || null;

export default editBlockReasonFor;
